<ng-container *transloco="let t; read: 'absenceScheduler'">
    <kendo-scheduler
      *ngIf="resources$ |async"
      [columnWidth]="60"
      [kendoSchedulerBinding]="events$ | async"
      [selectedViewIndex]="1"
      [selectedDate]="selectedDate"
      [resources]="resources$ | async"
      [group]="group"
      [weekStart]="weekStart"
      [slotClass]="setSlotBackgroundColor"
      [eventClass]="setEventClass"
      (dateChange)="onDateChange($event)"
      [showWorkHours]="true"
      class="absenceScheduler"
      [workDayStart]="(tenantSettings$ | async).startMorningWorkTime"
      [workDayEnd]="(tenantSettings$ | async).endAfternoonWorkTime"
  >
    <ng-template kendoSchedulerGroupHeaderTemplate let-resource="resource">
      <span [style.color]="resource.color">{{ resource.text }}</span>
      <p class="ressourceDepartment" *ngIf="resource.department">
        {{ resource.department }}
      </p>
    </ng-template>

    <ng-template kendoSchedulerDateHeaderTemplate let-date="date">
      <strong>{{ date | date: "EEEEEE dd." }}</strong>
      @if (holidayName(date); as name) {
        <span class="holiday-name" [title]="name">{{ name }}</span>
      }
    </ng-template>


    <kendo-scheduler-timeline-week-view
      [slotDivisions]="1"
      [slotDuration]="300"
      [workWeekStart]="1"
    >
    </kendo-scheduler-timeline-week-view>

    <kendo-scheduler-timeline-month-view
      [slotDivisions]="1"
      [slotDuration]="600"
      [workWeekStart]="1"
    >
    </kendo-scheduler-timeline-month-view>

    <kendo-scheduler-messages
      [calendarToday]="'Heute'"
      [today]="'Heute'"
      [timelineViewTitle]="'Zeitachse'"
      [timelineWeekViewTitle]="'Zeitachse Woche'"
      [timelineMonthViewTitle]="'Zeitachse Monat'"
      [showWorkDay]="'Arbeitstag anzeigen'"
      [showFullDay]="'Ganzer Tag anzeigen'"
      [nextTitle]="'nächster Tag'"
      [previousTitle]="'vorheriger Tag'"
      deleteDialogTitle="Eintrag Löschen"
      deleteConfirmation="Eintrag wirklich löschen?"
      cancel="Abbrechen"
      destroy="Löschen"
    >
    </kendo-scheduler-messages>
    
  </kendo-scheduler>
</ng-container>